function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 21.624,
  cy: 4.329,
  r: 3.19,
  stroke: "#FF9800",
  strokeWidth: 1.906
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 21.622,
  cy: 4.331,
  r: 0.97,
  fill: "#FF9800"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 20.508,
  y: 7.07,
  width: 2.084,
  height: 5.358,
  rx: 1.042,
  fill: "#FF9800"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.627,
  cy: 16.096,
  r: 3.133,
  stroke: "#FF9800",
  strokeWidth: 1.906
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.626,
  cy: 16.099,
  r: 0.956,
  fill: "#FF9800"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 11.354,
  y: 18.793,
  width: 2.083,
  height: 5.283,
  rx: 1.041,
  fill: "#FF9800"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.019,
  cy: 25.361,
  r: 3.203,
  stroke: "#FF9800",
  strokeWidth: 1.906
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.018,
  cy: 25.363,
  r: 0.973,
  fill: "#FF9800"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 23.895,
  y: 28.334,
  width: 2.084,
  height: 5.374,
  rx: 1.042,
  fill: "#FF9800"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.808 8.804a3.177 3.177 0 00-2.276-2.398l-.521 2.51c.158.089.273.24.312.422l1.818 8.46c.142.66.621 1.195 1.261 1.408l2.583.861a.635.635 0 01.426.7l-2.194 14.056a.636.636 0 01-.482.52l-12.34 2.908a1.27 1.27 0 01-1.48-.787l-.142-.375a1.906 1.906 0 00-2.451-1.11L4.26 39.372a1.27 1.27 0 01-1.698-1.408l3.864-22.16a.635.635 0 01.06-.182l.53-2.885a3.176 3.176 0 00-3.094 2.63L.06 37.529c-.506 2.903 2.333 5.258 5.092 4.224l8.476-3.174a3.812 3.812 0 004.35 2.146l12.341-2.907a3.176 3.176 0 002.41-2.602l2.194-14.055a3.176 3.176 0 00-2.134-3.504l-2.238-.746-1.742-8.106zm-18.788.698l.72-3.544a3.176 3.176 0 013.863-2.453l1.854.45-.639 2.46-1.815-.441a.635.635 0 00-.773.49l-.682 3.358-2.528-.32z",
  fill: "#FF9800"
});

function SvgState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 42,
    viewBox: "0 0 35 42",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

export default SvgState;